<div class="dialogContent calcHeight content">
  <irb-settings-dialog-banner [accordian]="accordian" [showUnsavedChangesWarning]="showUnsavedChangesWarning"
  [isModified]="isModified" [validationErrorTemplates]="validationErrorTemplates" (save)="save()">Rebalancing</irb-settings-dialog-banner>
  <div class="body">
    <mat-accordion #accordian="matAccordion" [multi]="true">
      @if (globalSettings) {
        @if (ENABLE_SETTINGS_HIST) {
          <mat-expansion-panel [expanded]="false" (opened)="iss.updateExpansionState('HISTORY','opened')" (closed)="iss.updateExpansionState('HISTORY','closed')">
            <mat-expansion-panel-header>
              <mat-panel-title>
                Settings History
              </mat-panel-title>
            </mat-expansion-panel-header>
            <ng-template matExpansionPanelContent>
              <irb-settings-history tabName="Rebalance"></irb-settings-history>
            </ng-template>
          </mat-expansion-panel>
        }
        <mat-expansion-panel id="TRADE_MIN" [expanded]="iss.getDefaultExpansionState('TRADE_MIN')"
          (opened)="iss.updateExpansionState('TRADE_MIN','opened')"
          (closed)="iss.updateExpansionState('TRADE_MIN','closed')">
          <mat-expansion-panel-header>
            <mat-panel-title>
              Trade Minimums
            </mat-panel-title>
          </mat-expansion-panel-header>
          <ng-template matExpansionPanelContent>
            <div class="block bottomBorder">
              <div style="margin-bottom:5px;">
                These minimum values will be applied by default to all securities in the iRebal security master...
                <a calltoaction [calltoactionTemplate]="tradeMinimumsTemplate">more</a>
              </div>
              <div class="left bold" style="width: 160px; display: inline-block;">Minimum buy amount</div>
              <div class="left">
                <div class="block">
                  <div class="left" style="width: 70px"><span class="bold">Min Buy</span> $</div>
                  <div class="left">
                    <irb-number-text-box [disabled]="!isadmin" #advisorImposedBuyMin
                      [(value)]="globalSettings.advisorImposedBuyMin"
                      places="0"
                      [min]="0"
                      [max]="999999999"
                      invalidMessage="Please enter whole numbers only"
                    invalidRangeMessage="" (change)="onInputChange()" width="70px"></irb-number-text-box>
                    <span style="margin: 0 10px">Apply to</span>
                    <irb-dropdown-filter #tradeApplyListForBuyDollar
                      [disabled]="!isadmin"
                      [(value)]="advisorMinBuyApplicableTo"
                      (search)="setDropDown($event, 'tradeApplyListForBuyDollar')"
                      size="34" hoverPanelWidth="275"
                    (valueChange)="onInputChange()"></irb-dropdown-filter>
                  </div>
                  <br class="clear"/>
                </div>
                <div>
                  <div class="left" style="width: 70px"><span class="bold">Min Buy</span> %</div>
                  <div class="left">
                    <irb-number-text-box [disabled]="!isadmin" #advisorImposedBuyMinPercent [(value)]="globalSettings.advisorImposedBuyMinPercent" places="2" min="0" max="100" invalidMessage="Please enter only numbers, with up to two decimal places." invalidRangeMessage="Please enter only numbers between 0 and 100." (change)="onInputChange()" width="70px"></irb-number-text-box>
                    <span style="margin: 0 10px">Apply to</span>
                    <irb-dropdown-filter #tradeApplyListForBuyPercentage
                      [disabled]="!isadmin"
                      [(value)]="advisorMinBuyPercentApplicableTo"
                      (search)="setDropDown($event, 'tradeApplyListForBuyPercentage')"
                      size="34" hoverPanelWidth="275"
                    (valueChange)="onInputChange()"></irb-dropdown-filter>
                  </div>
                  <br class="clear"/>
                </div>
              </div>
              <br class="clear"/>
            </div>
            <div>
              <div class="left bold" style="width: 160px; display: inline-block;">Minimum sell amount</div>
              <div class="left">
                <div class="block">
                  <div class="left" style="width: 70px"><span class="bold">Min Sell</span> $</div>
                  <div class="left">
                    <irb-number-text-box [disabled]="!isadmin" #advisorImposedSellMin
                      [(value)]="globalSettings.advisorImposedSellMin"
                      places="0"
                      [min]="0"
                      [max]="999999999"
                    invalidMessage="Please enter whole numbers only" invalidRangeMessage="" (change)="onInputChange()" width="70px"></irb-number-text-box>
                    <span style="margin: 0 10px">Apply to</span>
                    <irb-dropdown-filter #tradeApplyListForSellDollar
                      [disabled]="!isadmin"
                      [(value)]="advisorMinSellApplicableTo"
                      (search)="setDropDown($event, 'tradeApplyListForSellDollar')"
                      size="34" hoverPanelWidth="275"
                    (valueChange)="onInputChange()"></irb-dropdown-filter>
                  </div>
                  <br class="clear"/>
                </div>
                <div>
                  <div class="left" style="width: 70px"><span class="bold">Min Sell</span> %</div>
                  <div class="left">
                    <irb-number-text-box [disabled]="!isadmin" #advisorImposedSellMinPercent [(value)]="globalSettings.advisorImposedSellMinPercent" places="2" min="0" max="100" invalidMessage="Please enter only numbers, with up to two decimal places." invalidRangeMessage="Please enter only numbers between 0 and 100." (change)="onInputChange()" width="70px"></irb-number-text-box>
                    <span style="margin: 0 10px">Apply to</span>
                    <irb-dropdown-filter #tradeApplyListForSellPercentage
                      [disabled]="!isadmin"
                      [(value)]="advisorMinSellPercentApplicableTo"
                      (search)="setDropDown($event, 'tradeApplyListForSellPercentage')"
                      size="34" hoverPanelWidth="275"
                    (valueChange)="onInputChange()"></irb-dropdown-filter>
                  </div>
                  <br class="clear"/>
                </div>
              </div>
              <br class="clear"/>
            </div>
          </ng-template>
        </mat-expansion-panel>
      }

      @if (globalSettings && isTlhWsaEnabled) {
        <mat-expansion-panel id="DIRECTED_TRADE"
          [expanded]="iss.getDefaultExpansionState('DIRECTED_TRADE')"
          (opened)="iss.updateExpansionState('DIRECTED_TRADE','opened')"
          (closed)="iss.updateExpansionState('DIRECTED_TRADE','closed')">
          <mat-expansion-panel-header>
            <mat-panel-title>
              Adjust Securities
            </mat-panel-title>
          </mat-expansion-panel-header>
          <ng-template matExpansionPanelContent>
            <div>
              <span class="bold" style="width: 150px; display: inline-block;">Adjust securities<span class="infoIcon" calltoaction
              [calltoactionTemplate]="directTradingTemplate">&nbsp;</span>
            </span>
            Include Equivalent and Alt Securities
            <p-radioButton id="includeEqAltSec" [disabled]="!isadmin" name="includeEqAltSec" #includeEqAltSecPos [value]="true"
            [(ngModel)]="globalSettings.includeEquivalentAndAltSecurities" (ngModelChange)="onInputChange()" inputId="setslitem1"></p-radioButton>
            <label for="setslitem1" [class.p-disabled]="!isadmin">Yes</label>
            <p-radioButton [disabled]="!isadmin" name="includeEqAltSec" #includeEqAltSecNeg [value]="false"
            [(ngModel)]="globalSettings.includeEquivalentAndAltSecurities" (ngModelChange)="onInputChange()" inputId="setslitem2"></p-radioButton>
            <label for="setslitem2" [class.p-disabled]="!isadmin">No</label>
          </div>
        </ng-template>
      </mat-expansion-panel>
    }

    @if (globalSettings && !isTlhWsaEnabled) {
      <mat-expansion-panel id="DIRECTED_TRADE1"
        [expanded]="iss.getDefaultExpansionState('DIRECTED_TRADE1')"
        (opened)="iss.updateExpansionState('DIRECTED_TRADE1','opened')"
        (closed)="iss.updateExpansionState('DIRECTED_TRADE1','closed')">
        <mat-expansion-panel-header>
          <mat-panel-title>
            Directed Trading
          </mat-panel-title>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <div>
            <span class="bold" style="width: 150px; display: inline-block;">Adjust securities<span class="infoIcon" calltoaction
            [calltoactionTemplate]="directTradingTemplate">&nbsp;</span>
          </span>
          Include Equivalent and Alt Securities
          <p-radioButton id="includeEqAltSec" [disabled]="!isadmin" name="includeEqAltSec" #includeEqAltSecPos [value]="true"
          [(ngModel)]="globalSettings.includeEquivalentAndAltSecurities" (ngModelChange)="onInputChange()" inputId="setslitem3"></p-radioButton>
          <label for="setslitem3" [class.p-disabled]="!isadmin">Yes</label>
          <p-radioButton [disabled]="!isadmin" name="includeEqAltSec" #includeEqAltSecNeg [value]="false"
          [(ngModel)]="globalSettings.includeEquivalentAndAltSecurities" (ngModelChange)="onInputChange()" inputId="setslitem4"></p-radioButton>
          <label for="setslitem4" [class.p-disabled]="!isadmin">No</label>
        </div>
        <div>
          <span class="bold" style="width: 150px; display: inline-block;">Tax loss harvesting<span class="infoIcon" calltoaction
          [calltoactionTemplate]="taxLossHarvestingTemplate">&nbsp;</span>
        </span>
        Remove the sell if iRebal is unable to purchase the replacement security?
        <p-radioButton id="revertTLHSell" [disabled]="!isadmin" name="revertTLHSell" #revertTLHSellPos [value]="true"
        [(ngModel)]="globalSettings.revertHarvestSellEnabled" (ngModelChange)="onInputChange()" inputId="setslitem5"></p-radioButton>
        <label for="setslitem5" [class.p-disabled]="!isadmin">Yes</label>
        <p-radioButton [disabled]="!isadmin" name="revertTLHSell" #revertTLHSellNeg [value]="false"
        [(ngModel)]="globalSettings.revertHarvestSellEnabled" (ngModelChange)="onInputChange()" inputId="setslitem6"></p-radioButton>
        <label for="setslitem6" [class.p-disabled]="!isadmin">No</label>
      </div>
    </ng-template>
  </mat-expansion-panel>
}

@if (globalSettings && isTlhWsaEnabled) {
  <mat-expansion-panel id="WASH_SALE_SETTINGS"
    [expanded]="iss.getDefaultExpansionState('WASH_SALE_SETTINGS')"
    (opened)="iss.updateExpansionState('WASH_SALE_SETTINGS','opened')"
    (closed)="iss.updateExpansionState('WASH_SALE_SETTINGS','closed')">
    <mat-expansion-panel-header>
      <mat-panel-title>
        Wash Sale Settings
      </mat-panel-title>
    </mat-expansion-panel-header>
    <ng-template matExpansionPanelContent>
      <div class="block" >Configure the following settings for wash sale recognition and allowance.</div>
      <div class="bold block">Wash Sale Settings</div>
      <div class="block bottomBorder">
        <p-checkbox [disabled]="!isadmin" name="washSaleSetting" [(ngModel)]="globalSettings.allowWashSaleBuys" binary="true" (onChange)="onInputChange()" inputId="setslitem7"></p-checkbox>
        <label for="setslitem7">Allow buys of securities sold at a loss within the last 30 days</label>
        <div [style]="{'pointer-events': (!isadmin || !globalSettings.allowWashSaleBuys) ? 'none' : ''}">
          <p-radioButton [disabled]="!isadmin || !globalSettings.allowWashSaleBuys" name="washSaleType" [value]="'Taxable Accounts Only'"
          [(ngModel)]="washSaleAccounts" (ngModelChange)="onInputChange()" inputId="setslitem8"></p-radioButton>
          <label for="setslitem8" [class.p-disabled]="!isadmin || !globalSettings.allowWashSaleBuys">Taxable Accounts Only</label>
        </div>
        <div [style]="{'pointer-events': (!isadmin || !globalSettings.allowWashSaleBuys) ? 'none' : ''}">
          <p-radioButton [disabled]="!isadmin || !globalSettings.allowWashSaleBuys" name="washSaleType" [value]="'All Accounts'"
          [(ngModel)]="washSaleAccounts" (ngModelChange)="onInputChange()" inputId="setslitem9"></p-radioButton>
          <label for="setslitem9" [class.p-disabled]="!isadmin || !globalSettings.allowWashSaleBuys">All Accounts</label>
        </div>
      </div>
      <a class="show-wash-sale-info" (click)="onClickWashSaleHowTo();">
        <img src="../../assets/images/schwab-blue-popup.png" style="vertical-align: text-bottom;">
        How does iRebal handle wash sale settings?
      </a>
    </ng-template>
  </mat-expansion-panel>
}

@if (globalSettings && isTlhWsaEnabled) {
  <mat-expansion-panel id="TLH" [expanded]="iss.getDefaultExpansionState('TLH')"
    (opened)="iss.updateExpansionState('TLH','opened')"
    (closed)="iss.updateExpansionState('TLH','closed')">
    <mat-expansion-panel-header>
      <mat-panel-title>
        Tax Loss Harvesting
      </mat-panel-title>
    </mat-expansion-panel-header>
    <ng-template matExpansionPanelContent>
      <div>
        <div class="block" style="display:flex;">
          <div class="bold" style="width: 135px;">Loss Detection Level</div>
          <div style="padding-left:15px;">
            <div class="block" style="font-size: 12px;color: #848484;">Set tax loss harvesting rebalances to calculate based on either lot or position levels.</div>
            <div>
              <p-radioButton name="tlhType" [value]="'lot'"
              [(ngModel)]="tlhType" (ngModelChange)="onTLHTypeChange('lot')" inputId="setslitem10"></p-radioButton>
              <label for="setslitem10">Lot Level</label>
            </div>
            <div>
              <p-radioButton name="tlhType" [value]="'position'"
              [(ngModel)]="tlhType" (ngModelChange)="onTLHTypeChange('position')" inputId="setslitem11"></p-radioButton>
              <label for="setslitem11">Position Level</label>
            </div>
          </div>
        </div>
        <div class="block" style="display:flex;">
          <div class="bold" style="width: 140px;">Minimum Threshold</div>
          <div style="padding-left:15px;">
            <div class="block" style="font-size: 12px;color: #848484;">Set the minimum threshold for tax loss harvesting. iRebal will use the larger of these two values.</div>
            <div class="block">
              <div style="display: inline-block;width:50px;">Min %</div>
              <irb-number-text-box [(value)]="globalSettings.tlhMinPerc" #tlhMinPercInput
                isRequired="true"
                places="2" min="0"  max="100"
                placeholder="Input amount"
                invalidRangeMessage="Please enter a value between 0..100"
              (change)="onInputChange()" width="140px"></irb-number-text-box>
            </div>
            <div>
              <div style="display: inline-block;width:50px;">Min $</div>
              <irb-number-text-box [(value)]="globalSettings.tlhMinDollarAmnt" #tlhMinDollarAmntInput
                isRequired="true"
                places="2" min="0"
                placeholder="Input amount"
              (change)="onInputChange()" width="140px"></irb-number-text-box>
            </div>
          </div>
        </div>
        <div class="bold block" style="border-top: 1px solid #ccc;padding-top: 10px;">Rebalance Types</div>
        <div class="block" style="display:flex;">
          <div class="bold" style="width: 135px;">Tax Loss Harvest</div>
          <div style="padding-left:15px;">
            <div class="block">What should iRebal do if it is not able to purchase a replacement security in a Tax Loss Harvest submission?</div>
            <div>
              <p-radioButton [disabled]="!isadmin" name="revertTLHSell" #revertTLHSellNeg [value]="true"
              [(ngModel)]="globalSettings.revertHarvestSellEnabled" (ngModelChange)="onInputChange()" inputId="setslitem12"></p-radioButton>
              <label for="setslitem12" [class.p-disabled]="!isadmin">Do not harvest security</label>
            </div>
            <div>
              <p-radioButton id="revertTLHSell" [disabled]="!isadmin" name="revertTLHSell" #revertTLHSellPos [value]="false"
              [(ngModel)]="globalSettings.revertHarvestSellEnabled" (ngModelChange)="onInputChange()" inputId="setslitem13"></p-radioButton>
              <label for="setslitem13" [class.p-disabled]="!isadmin">Harvest security</label>
            </div>
          </div>
        </div>
        <div class="bold block">Tax Loss Harvest & Full Rebalance</div>
        <div style="padding-bottom: 5px;">If a wash sale alternative is not available for a security, iRebal will not harvest the security in a Tax Loss Harvest & Full Rebalance submission.</div>
        <div class="block">
          <a class="show-wash-sale-info" target="_blank" [href]="learnMoreUrl">
            <img src="../../assets/images/schwab-blue-popup.png" style="vertical-align: text-bottom;">
            Learn more about how iRebal handles tax loss harvesting
          </a>
        </div>
        <div class="bold block" style="border-top: 1px solid #ccc;padding-top: 10px;">Security Settings</div>
        <div class="block">Securities must be enabled individually for harvesting. Adjust settings on the securities page.</div>
        <button class="btn-medium-primary chevron-right" (click)="goToSecurities()">Go to Securities</button>
      </div>
    </ng-template>
  </mat-expansion-panel>
}

@if (globalSettings) {
  <mat-expansion-panel id="TAX_FEES" [expanded]="iss.getDefaultExpansionState('TAX_FEES')"
    (opened)="iss.updateExpansionState('TAX_FEES','opened')"
    (closed)="iss.updateExpansionState('TAX_FEES','closed')">
    <mat-expansion-panel-header>
      <mat-panel-title>
        Taxes & Fees
      </mat-panel-title>
    </mat-expansion-panel-header>
    <ng-template matExpansionPanelContent>
      <div class="block">
        <span class="bold">Stop sales within</span>
        <span class="infoIcon" calltoaction
        [calltoactionTemplate]="stopSalesWithinTemplate">&nbsp;</span>&nbsp;
        <irb-number-text-box [disabled]="!isadmin" #dontSellShortTermGainDays
          [(value)]="globalSettings.dontSellShortTermGainDays" min="0" max="364"
          invalidMessage="Please enter whole numbers only"
          invalidRangeMessage="Please enter only numbers between 0 and 364."
        (change)="onInputChange()" width="70px"></irb-number-text-box>
        days of a short term gain becoming a long term gain. (0-364)
      </div>
      <div>
        <span class="bold">Stop sales with redemption penalty fees</span>
        <span class="infoIcon" calltoaction
        [calltoactionTemplate]="stopSalesWithRedemptionTemplate">&nbsp;</span>&nbsp;
        <p-radioButton id="dontSellPenalty" [disabled]="!isadmin" name="dontSellPenalty" #dontSellPenaltyPos [value]="true"
        [(ngModel)]="globalSettings.avoidRedemptionPenalty" (ngModelChange)="validateMFRules()" inputId="setslitem14"></p-radioButton>
        <label for="setslitem14" [class.p-disabled]="!isadmin">Yes</label>
        <p-radioButton [disabled]="!isadmin" name="dontSellPenalty" #dontSellPenaltyNeg [value]="false"
        [(ngModel)]="globalSettings.avoidRedemptionPenalty" (ngModelChange)="onInputChange()" inputId="setslitem15"></p-radioButton>
        <label for="setslitem15" [class.p-disabled]="!isadmin">No</label>
      </div>
    </ng-template>
  </mat-expansion-panel>
}

@if (globalSettings) {
  <mat-expansion-panel id="OPTIONS" [expanded]="iss.getDefaultExpansionState('OPTIONS')"
    (opened)="iss.updateExpansionState('OPTIONS','opened')" (closed)="iss.updateExpansionState('OPTIONS','closed')">
    <mat-expansion-panel-header>
      <mat-panel-title>
        Options
      </mat-panel-title>
    </mat-expansion-panel-header>
    <ng-template matExpansionPanelContent>
      <div>
        <span class="bold">Prevent sale of equity with covered call</span><span class="infoIcon" calltoaction
      [calltoactionTemplate]="preventSaleOfEquityTemplate">&nbsp;</span>&nbsp;
      <p-radioButton id="preventEqtySaleCC"  name="preventEqtySaleCC" #preventEqtySaleCCPos [value]="true"
        [(ngModel)]="globalSettings.ccPreventEquitySale" (ngModelChange)="onInputChange()"
      [disabled]="!isadmin || globalSettings.ccClosePosition" inputId="setslitem16"></p-radioButton>
      <label for="setslitem16" [class.p-disabled]="!isadmin || globalSettings.ccClosePosition">Yes</label>
      <p-radioButton [disabled]="!isadmin" name="preventEqtySaleCC" #preventEqtySaleCCNeg [value]="false"
      [(ngModel)]="globalSettings.ccPreventEquitySale" (ngModelChange)="onInputChange()" inputId="setslitem17"></p-radioButton>
      <label for="setslitem17" [class.p-disabled]="!isadmin">No</label>
    </div>
    <div>
      <span class="bold">Close corresponding covered call position when selling equities</span><span class="infoIcon" calltoaction
    [calltoactionTemplate]="closeCorrespondingCoveredCallTemplate">&nbsp;</span>&nbsp;
    <p-radioButton id="ccClosePosition" [disabled]="!isadmin" name="ccClosePosition" #ccClosePositionPos [value]="true"
    [(ngModel)]="globalSettings.ccClosePosition" (ngModelChange)="onClosePositionYes()" inputId="setslitem18"></p-radioButton>
    <label for="setslitem18" [class.p-disabled]="!isadmin">Yes</label>
    <p-radioButton [disabled]="!isadmin" name="ccClosePosition" #ccClosePositionNeg [value]="false"
    [(ngModel)]="globalSettings.ccClosePosition" (ngModelChange)="onClosePositionNo()" inputId="setslitem19"></p-radioButton>
    <label for="setslitem19" [class.p-disabled]="!isadmin">No</label>
  </div>
</ng-template>
</mat-expansion-panel>
}

@if (globalSettings) {
  <mat-expansion-panel id="TAX_SENSITIVITY"
    [expanded]="iss.getDefaultExpansionState('TAX_SENSITIVITY')"
    (opened)="iss.updateExpansionState('TAX_SENSITIVITY','opened')"
    (closed)="iss.updateExpansionState('TAX_SENSITIVITY','closed')">
    <mat-expansion-panel-header>
      <mat-panel-title>
        Tax Sensitivity
      </mat-panel-title>
    </mat-expansion-panel-header>
    <ng-template matExpansionPanelContent>
      <span class="bold">Tax sensitivity for all portfolios</span><span class="infoIcon" calltoaction
    [calltoactionTemplate]="taxSensitivityTemplate">&nbsp;</span>&nbsp;
    <p-radioButton id="taxSettingsMax"[disabled]="!isadmin" #taxSettingsMax name="taxSettings" value="MAX" [(ngModel)]="globalSettings.taxSettings"
    (ngModelChange)="onInputChange()" inputId="setslitem20"></p-radioButton>
    <label for="setslitem20" [class.p-disabled]="!isadmin">Max</label>
    <p-radioButton [disabled]="!isadmin" #taxSettingsHigh name="taxSettings" value="HIGH" [(ngModel)]="globalSettings.taxSettings"
    (ngModelChange)="onInputChange()" inputId="setslitem21"></p-radioButton>
    <label for="setslitem21" [class.p-disabled]="!isadmin">High</label>
    <p-radioButton [disabled]="!isadmin" #taxSettingsMedium name="taxSettings" value="MEDIUM" [(ngModel)]="globalSettings.taxSettings"
    (ngModelChange)="onInputChange()" inputId="setslitem22"></p-radioButton>
    <label for="setslitem22" [class.p-disabled]="!isadmin">Medium</label>
    <p-radioButton [disabled]="!isadmin" #taxSettingsLow name="taxSettings" value="LOW" [(ngModel)]="globalSettings.taxSettings"
    (ngModelChange)="onInputChange()" inputId="setslitem23"></p-radioButton>
    <label for="setslitem23" [class.p-disabled]="!isadmin">Low</label>
  </ng-template>
</mat-expansion-panel>
}
</mat-accordion>
</div>
</div>
<ng-template #tradeMinimumsTemplate>
  <p>These minimum values will be applied by default to all securities in the iRebal security master (unless changed in the individual security’s record). For mutual funds, if you set both a dollar and a percent minimum, they will be compared to the applicable fund minimums, and the highest of these values will take precedence.</p>
  <p>New values you specify here can be written to existing securities as indicated.</p>
</ng-template>
<ng-template #directTradingTemplate>
  <p>If an Adjust securities rebalance is submitted and this setting is set to Yes, iRebal will include equivalent and alternative securities in the target percentage calculations. Equivalent and alternative securities may also be sold or purchased in place of the targeted security to achieve the desired target allocation.</p>
  <p>Note: Equivalents and alternatives will only be included in the calculations if they exist in the client's assigned model.</p>
</ng-template>
<ng-template #taxLossHarvestingTemplate>
  When set to Yes, if iRebal is unable to purchase the replacement security, it will cancel the sell and the loss will not be harvested. Alternatively, if set to No, iRebal will still harvest the loss but the replacement will not be purchased and the proceeds will be left in cash.
</ng-template>
<ng-template #stopSalesWithinTemplate>
  If a lot identified to sell is about to convert to a long-term gain (e.g. it's 5 days away from being converted), you can choose to automatically STOP that sale.
  If you don't ever want to take a short-term gain, set this to 364.
</ng-template>
<ng-template #stopSalesWithRedemptionTemplate>
  If a fund identified to sell will trigger a redemption penalty fee, you can choose to avoid this sale.
</ng-template>
<ng-template #preventSaleOfEquityTemplate>
  If a short call is written against an underlying equity position and no long call for the same equity is in the account, shares of the underlying equity will be marked as do not sell.
</ng-template>
<ng-template #closeCorrespondingCoveredCallTemplate>
  If set to Yes, iRebal will also close out the necessary option contracts to prevent you from having naked short option positions.
</ng-template>
<ng-template #taxSensitivityTemplate>
  For all taxable sales, this setting helps determine the order in which securities and taxlots will be sold.
</ng-template>
